module.exports = __webpack_public_path__ + "img/carcredible.b9614e4c.png";